<div class="border-default overflow-x-auto rounded-md border">
  <table class="w-full border-collapse text-xs">
    <thead class="border-default border-b">
      <tr>
        <th class="table-header px-3 py-2 text-left align-bottom whitespace-nowrap">
          {{ 'visualization.occupation.table.site' | translate }}
        </th>
        <th class="table-header px-3 py-2 text-left align-bottom whitespace-nowrap">
          {{ 'visualization.occupation.table.infrastructure' | translate }}
        </th>
        <th class="table-header px-3 py-2 text-right align-bottom whitespace-nowrap">
          {{ 'visualization.occupation.table.available' | translate }}
        </th>
        <th class="table-header px-3 py-2 text-right align-bottom whitespace-nowrap">
          {{ 'visualization.occupation.table.peak' | translate }}
        </th>
        <th class="table-header px-3 py-2 text-right align-bottom whitespace-nowrap">
          {{ 'visualization.occupation.table.peak_utilization' | translate }}
        </th>
        <th class="table-header px-3 py-2 text-right align-bottom whitespace-nowrap">
          {{ 'visualization.occupation.table.mean_utilization' | translate }}
        </th>
        <th class="table-header px-3 py-2 text-right align-bottom whitespace-nowrap">
          {{ 'visualization.occupation.table.busy' | translate }}
        </th>
        <th class="table-header px-3 py-2 text-right align-bottom whitespace-nowrap">
          {{ 'visualization.occupation.table.over' | translate }}
        </th>
        <th class="table-header px-3 py-2 text-left align-bottom whitespace-nowrap">
          {{ 'visualization.occupation.table.state' | translate }}
        </th>
      </tr>
    </thead>
    <tbody>
      @for (row of rows(); track row.siteUid + row.name) {
        <tr class="table-row">
          <td class="table-cell py-2">{{ row.siteUid }}</td>
          <td class="table-cell py-2">{{ row.name }}</td>
          <td class="table-cell py-2 text-right font-mono tabular-nums">
            {{ row.capacity }}
          </td>
          <td class="table-cell py-2 text-right font-mono tabular-nums">{{ row.peak }}</td>
          <td class="table-cell py-2 text-right font-mono tabular-nums">
            {{ row.peakUtilization }}
          </td>
          <td class="table-cell py-2 text-right font-mono tabular-nums">
            {{ row.meanUtilization }}
          </td>
          <td class="table-cell py-2 text-right font-mono tabular-nums">{{ row.busy }}</td>
          <td class="table-cell py-2 text-right font-mono tabular-nums">{{ row.over }}</td>
          <td class="table-cell py-2">
            <span
              class="inline-flex items-center gap-1 text-[11px] font-semibold whitespace-nowrap">
              <i [class]="stateIcon(row.state)"></i>
              {{ 'visualization.occupation.state.' + row.state | translate }}
            </span>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
